var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsDarkIdle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4853 26L19.364 35.1213C18.7474 35.7379 17.9293 36.03 17.1217 35.9976C17.0813 35.9992 17.0408 36 17 36H13C11.3431 36 10 34.6569 10 33C10 31.3431 11.3431 30 13 30H16L25.0662 20.9338C25.3233 20.6767 25.6154 20.4761 25.9272 20.3318C26.3386 20.1197 26.8053 20 27.3 20H31C32.6568 20 34 21.3431 34 23C34 24.6569 32.6568 26 31 26H28.4853Z",
    fill: "white",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsDarkIdle);
export default __webpack_public_path__ + "static/media/es-dark-idle.ae6c02d53d452b20c41cc256f2c9dbcd.svg";
export { ForwardRef as ReactComponent };